import { CSSProperties } from 'react';

export interface ClassNameObject {
    [className: string]: any;
}

type ArgT = ClassNameObject | string | undefined;

export const classNameMerger = baseClassNameMerger();

export function baseClassNameMerger(baseClass?: string): (...args: ArgT[]) => string {
    return (...args: ArgT[]) => {
        const res: string[] = [];

        for (const arg of args) {
            if (typeof arg === 'string') {
                res.push((baseClass ? baseClass : '') + arg);
            } else if (typeof arg === 'object') {
                for (const className in arg) {
                    if (arg[className]) {
                        res.push((baseClass ? baseClass : '') + className);
                    }
                }
            }
        }

        return res.join(' ');
    };
}

export function transformStyles(ss: string): CSSProperties {
    const res: CSSProperties = {};

    for (const prop of ss.split(';')) {
        if (prop.length) {
            const [key, val] = prop.split(':').map((a) => a.trim());
            const camelKey = kebab2camel(key);

            res[camelKey] = val;
        }
    }

    return res;
}

export const kebab2camel = (s: string) =>
    s
        .split('-')
        .map((a, i) => (i === 0 ? a : a[0].toUpperCase() + a.substr(1)))
        .join('');

export function getElementOffset(el: HTMLElement): { left: number; top: number } {
    if (el.offsetParent !== null) {
        const offset = getElementOffset(el.offsetParent as HTMLElement);

        return {
            left: el.offsetLeft + offset.left,
            top: el.offsetTop + offset.top
        };
    }

    return {
        left: el.offsetLeft,
        top: el.offsetTop
    };
}

export function htmlEscape(text: unknown): string {
    if (text == null) {
        return '';
    }

    if (typeof text !== 'string') {
        return String(text);
    } //does not require escaping

    return text.replace(
        /[&<>'"]/g,
        (a) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&apos;', '"': '&quot;' })[a] ?? 'a'
    );
}

export function formatDate(date: Date) {
    // its always gonna be 'YYYY-MM-DD HH:mm:ss'
    const M = `0${date.getMonth() + 1}`.slice(-2);
    const D = `0${date.getDay()}`.slice(-2);
    const h = `0${date.getHours()}`.slice(-2);
    const m = `0${date.getMinutes()}`.slice(-2);
    const s = `0${date.getSeconds()}`.slice(-2);

    return `${date.getFullYear()}-${M}-${D}-${h}:${m}:${s}`;
}

export const RE_EMAIL = /^[#A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i; // copied from core

export const validatePhone = (text: string) => {
    if (!/^\+?\d[ \d-]+$/.test(text) || /[ -]{2,}/.test(text)) {
        return false;
    }

    return text.replace(/\D/g, '').length > 6;
};

export const getRedirectUrl = (redirectUrl: string) => {
    if (!redirectUrl || redirectUrl.startsWith('http')) return redirectUrl;
    const url = new URL(`${window.location.protocol + redirectUrl}`);

    return url.toString();
};
